import React from 'react'

import InputGroup from '../../../../../../UI/Forms/InputGroup/InputGroup'
import { updateFormOptions } from '../../../../../../../helpers/utils'
import PositionActions from './PositionActions/PositionActions'
import { Grid } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const PositionRow = ({
  index,
  positionForm,
  rowInputChanged,
  actionToClicked,
  delegateClicked,
  deleteClicked,
  dropdownOptions,
  primaryRowIndex,
  edit
}) => {
  const theme = useTheme()
  const Other = useMediaQuery(theme.breakpoints.up('lg'))

  let mainJob = null
  let active = null
  let form = Object.entries(positionForm).map(formItem => {
    let [formKey, formAttrs] = formItem
    // let xs

    if (formAttrs.elementType === 'static') {
      return null
    }

    if (['action2', 'delegate'].includes(formKey)) return null

    if ('weight_percent' === formKey) {
      formAttrs.value = formAttrs.value === '.00' ? 0 : formAttrs.value
    }
    if ('index' === formKey) {
      if (formKey === 'index') {
        formAttrs.value = index + 1
      }
    }

    let formWithOptions = null

    if (formKey === 'company_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.companyOptions,
        { ...formAttrs },
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company',
        false,
        false
      )
    } else if (formKey === 'org_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.orgOptions.filter(
          item => +item.company_id === +positionForm.company_id.value?.value
        ),
        { ...formAttrs },
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization',
        false,
        false
      )
    } else if (formKey === 'level_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.empLevelOptions.filter(
          item => +item.company_id === +positionForm.company_id.value?.value
        ),
        { ...formAttrs },
        'level_id',
        'level_id',
        'level_name',
        'Select Level',
        false,
        false
      )
    } else if (formKey === 'position_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.positionOptions.filter(
          item => +item.company_id === +positionForm.company_id.value?.value
        ),
        { ...formAttrs },
        'position_id',
        'position_id',
        'position_name',
        'Select Position',
        false,
        false
      )
    } else {
      formWithOptions = { ...formAttrs }
    }
    if (
      [
        'index',
        'company_id',
        'org_id',
        'level_id',
        'position_id',
        'effective_date',
        'is_main_job'
      ].includes(formKey)
    ) {
      formWithOptions.elementConfig = {
        ...formWithOptions.elementConfig
        // disabled: !edit
      }
    }
    if (formKey === 'is_main_job') {
      mainJob = (
        <Grid item xs style={{ whiteSpace: 'nowrap' }}>
          <InputGroup
            key={formKey}
            label={formWithOptions.label}
            inputType={formWithOptions.elementType}
            configs={formWithOptions.elementConfig}
            invalid={!formWithOptions.valid}
            validations={formWithOptions.validation}
            touched={formWithOptions.touched}
            changed={e => rowInputChanged(formKey, e)}
            inputValue={formWithOptions.value}
            validationError={formWithOptions.error}
            disabled={primaryRowIndex !== null && !edit ? primaryRowIndex !== index : false}
            noMargin
            datePickerFixHeight
          />
        </Grid>
      )
      return null
    }
    if (formKey === 'is_active') {
      active = (
        <Grid item xs>
          <InputGroup
            key={formKey}
            label={formWithOptions.label}
            inputType={formWithOptions.elementType}
            configs={formWithOptions.elementConfig}
            invalid={!formWithOptions.valid}
            validations={formWithOptions.validation}
            touched={formWithOptions.touched}
            changed={e => rowInputChanged(formKey, e)}
            inputValue={formWithOptions.value}
            validationError={formWithOptions.error}
            // disabled={primaryRowIndex !== null && !edit ? primaryRowIndex !== index : false}
            noMargin
            datePickerFixHeight
          />
        </Grid>
      )
      return null
    }
    return (
      <Grid item xs={6} sm={12} md={2} lg>
        <InputGroup
          key={formKey}
          label={formWithOptions.label}
          inputType={formWithOptions.elementType}
          configs={formWithOptions.elementConfig}
          invalid={!formWithOptions.valid}
          validations={formWithOptions.validation}
          touched={formWithOptions.touched}
          changed={e => rowInputChanged(formKey, e)}
          inputValue={formWithOptions.value}
          validationError={formWithOptions.error}
          // disabled={primaryRowIndex !== null && !edit ? primaryRowIndex !== index : false}
          noMargin
          datePickerFixHeight
        />
      </Grid>
    )
  })
  let check = (
    <>
      {Other ? (
        <Grid item style={{ marginTop: '-20px' }}>
          {mainJob}
          {active}
        </Grid>
      ) : (
        <Grid
          container
          item
          direction={'row'}
          alignItems={'flex-end'}
          justify={'flex-start'}
          md={4}
          lg={3}
          style={{ marginTop: 7 }}>
          {mainJob}
          {active}
          <PositionActions
            actionToClicked={actionToClicked}
            delegateClicked={delegateClicked}
            deleteClicked={deleteClicked}
          />
        </Grid>
      )}
    </>
  )
  return (
    <Grid container direction={'row'} spacing={1} justify={'flex-start'}>
      {form}
      {check}
      {Other ? (
        <Grid item style={{ marginTop: '-22px' }}>
          <PositionActions
            actionToClicked={actionToClicked}
            delegateClicked={delegateClicked}
            deleteClicked={deleteClicked}
          />
        </Grid>
      ) : null}
    </Grid>
  )
}

export default PositionRow
